import { WithDeleted } from '@common/typescript/objects/WithDeleted';

import { Location } from '@commonTuna/react/objects/BaseLocation';

export enum AmenityType {
	AcceptsInsurance = 1,
	AcceptsCreditCards = 2,
	AcceptsApplePay = 3,
	AcceptsAndroidPay = 4,
	AcceptsCryptocurrency = 5,
	FreeWiFi = 6,
	PaidWiFi = 7,
	StreetParking = 8,
	PrivateLotParking = 9,
	GarageParking = 10,
	BikeParking = 11,
	OffersMilitaryDiscount = 12,
	GoodForKids = 13,
	WheelchairAccessible = 14,
	Quiet = 15,
	OpenToAll = 16,
	ByAppointmentOnly = 17,
}

export const AmenityTypeNames = {
	[AmenityType.AcceptsInsurance]: 'Accepts Insurance',
	[AmenityType.AcceptsCreditCards]: 'Accepts Credit Cards',
	[AmenityType.AcceptsApplePay]: 'Accepts Apple Pay',
	[AmenityType.AcceptsAndroidPay]: 'Accepts Android Pay',
	[AmenityType.AcceptsCryptocurrency]: 'Accepts Cryptocurrency',
	[AmenityType.FreeWiFi]: 'Free Wi-Fi',
	[AmenityType.PaidWiFi]: 'Paid Wi-Fi',
	[AmenityType.StreetParking]: 'Street Parking',
	[AmenityType.PrivateLotParking]: 'Private Lot Parking',
	[AmenityType.GarageParking]: 'Garage Parking',
	[AmenityType.BikeParking]: 'Bike Parking',
	[AmenityType.OffersMilitaryDiscount]: 'Offers Military Discount',
	[AmenityType.GoodForKids]: 'Good For Kids',
	[AmenityType.WheelchairAccessible]: 'Wheelchair Accessible',
	[AmenityType.Quiet]: 'Quiet',
	[AmenityType.OpenToAll]: 'Open To All',
	[AmenityType.ByAppointmentOnly]: 'By Appointment Only',
};

export interface Amenity extends WithDeleted {
	locationId: number;
	location?: Location;

	amenityType: AmenityType;
}
